import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { WoOrderSortingService } from 'src/app/core/services/wo-order/wo-order-sorting.service';
import { BreadcrumbService } from 'src/app/layout/topbar/app.breadcrumb.service';
import { ScUserMessageInput, ScUserMessageOutput, ScUserOutput } from 'src/app/models/response/sc-user.model';
import { WoOrderOutput } from 'src/app/features/wo-order/wo-order.model';

@Component({
  selector: 'app-sc-user-message-chat',
  // standalone: true,
  // imports: [],
  templateUrl: './sc-user-message-chat.component.html',
  styleUrl: './sc-user-message-chat.component.scss'
})
export class ScUserMessageChatComponent implements OnInit {
  public list: ScUserMessageOutput[] = [];
  public language: string = "pt-BR";

  public flUpdate: boolean = true;

  public message: string = "";
  public pageMessage: string = "";
  public classBtnUpd: string = "p-button p-button-success p-m-1 mr-1";
  public classBtnDel: string = "p-button p-button-danger p-m-1 mr-1";
  public classBtnReset: string = "p-button p-button-warning p-m-1 mr-1";
  listMessages: any[];
  chatMessageDialog: boolean = false;
  chatList: any[] = [];

  displaySendMessage: boolean = false;
  dialogHeaderSendMessage: string = '';
  woOrder: WoOrderOutput = {};
  woOrderIdSelected: string = '';

  listUser: ScUserOutput [] = [];
  userId!: string;
  sourceUserId!: string; // User who sent the message

  isClient!: boolean;
  selectedItem!: any;
  payload!: ScUserMessageInput;
  @ViewChild('inputMessage') inputMessage: ElementRef<HTMLInputElement>;
  isOrder: boolean = false;

  constructor(private userService: ScUserService,
    private userTokenService: UserTokenService,
    private translateService: TranslateService,
    private translateConfigService: TranslateConfigService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private orderSortingService: WoOrderSortingService,
    private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.isClient = this.userTokenService.hasPermissionArray(['ROLE_CLIENT']);
    this.userId = this.userTokenService.getUserId();
    this.language = this.translateConfigService.getLanguage();

    this.flUpdate = this.userTokenService.hasPermissionArray(['SF_ADMIN', 'SC_MANAGER_U']);

    if (this.flUpdate == false) {
      this.classBtnDel = this.classBtnReset = "p-button p-button-secondary p-m-1 mr-1";
    }

    this.getList();
  }

  translate() {
    const labAccessControl = this.translateService.instant('label.access_control') + " ";
    const labUser = " " + this.translateService.instant('label.users');
    this.breadcrumbService.setItems([{ label: labAccessControl }, { label: labUser, routerLink: ['user'] }]);

    this.pageMessage = this.translateService.instant('grid.showing') + " {first} " + this.translateService.instant('grid.to') + " {last} " + this.translateService.instant('grid.of') + " {totalRecords} " + this.translateService.instant('grid.entries')
  }

  getList() {
    let userId = this.userTokenService.getUserId();
    this.userService.getListUserMessage(`TargetUserId_SourceUserId = ${userId}`).subscribe(
      {
        next: (res) => {
          if (res)
            this.list = res.data;
          let listMessageOrder = this.groupByUserMessage(this.list.filter(f => f.woOrderId != null), 'code', 'message', 'woOrderId', 'woOrderPictureUri', true);
          let listMessageTargetUser = this.groupByUserMessage(this.list.filter(f => f.isSendNotification != true && f.targetUserId != this.userId), 'targetUserName', 'message', 'targetUserId', 'targetPictureUri', false);
          let listMessageSourceUser = this.groupByUserMessage(this.list.filter(f => f.isSendNotification != true && f.sourceUserId != this.userId), 'sourceUserName', 'message', 'sourceUserId', 'sourcePictureUri', false);

          this.listMessages = listMessageOrder;
          this.listMessages.push(...listMessageTargetUser);
          this.listMessages.push(...listMessageSourceUser);

          this.listMessages.forEach(item => {
            item.length = item.Elements?.filter(f => f.targetUserId == userId && f.isView != true)?.length;
          });

          this.listMessages = this.listMessages.sort((a, b) => {
            return new Date(b.Elements[0].dateOfRegistration).getTime() - new Date(a.Elements[0].dateOfRegistration).getTime();
          });

          let listMessagesGroup = this.groupByUserMessageTotal(this.listMessages, 'Key', 'Label', 'UserId', 'PictureUri', 'IsOrder');
          this.listMessages = listMessagesGroup;

          this.translate();
        },
        error: (err) => console.log(`UserGrid - getList : ${err}.`)
      });
  }

  groupByUserMessage(colecao, propriedade, label, id, pictureUri, isOrder: boolean) {
    var agrupado = [];
    colecao.forEach(function (i) {
      var foiAgrupado = false;
      agrupado.forEach(function (j) {
        if (j.Key == i[propriedade]) {
          j.Elements.push(i);
          foiAgrupado = true;
        }
      });
      if (!foiAgrupado) agrupado.push({ Key: i[propriedade], UserId: i[id], Label: i['woOrderId'] != null ? '' : i[label], IsOrder: isOrder, Elements: [i], PictureUri: i[pictureUri] || '', length: i.length || 0 });
    });
    return agrupado;
  }

  groupByUserMessageTotal(colecao, propriedade, label, id, pictureUri, IsOrder) {
    var agrupado = [];
    colecao.forEach(function (i) {
      var foiAgrupado = false;
      agrupado.forEach(function (j) {
        if (j.Key == i[propriedade]) {
          i.Elements.forEach(function (el) {
            j.Elements.push(el);
          });
          foiAgrupado = true;
        }
      });
      if (!foiAgrupado) agrupado.push({ Key: i[propriedade], UserId: i[id], Label: i[label], IsOrder: i[IsOrder], Elements: i?.Elements, PictureUri: i[pictureUri] || '', length: i.length || 0 });
    });
    return agrupado;
  }

  openChatMessageDialog(item) {

    this.isOrder = item?.IsOrder || false;
    this.selectedItem = item;
    this.message = '';

    if (item.IsOrder) {
      this.orderSortingService.getItem(item.Elements[0].woOrderId).subscribe(
        {
          next: (res) => {
            if (res) {
              this.woOrder = res.data;
              if (this.woOrder != null && this.woOrder != undefined && (this.woOrder.obs == null || this.woOrder.obs == undefined || this.woOrder.obs == '')) {
                this.woOrder.obs = ' - ';
              }

              this.chatMessageDialog = true;
              this.chatList = item.Elements;
              this.chatList = this.chatList.sort((a, b) => b.dateOfRegistration - a.dateOfRegistration);
              this.chatList.forEach(chat => {
                chat.length = item.Elements?.filter(f => f.isView != true)?.length;
              });
            }
          },
          error: (err) => {
            console.log(`SfcDashboardServiceComponent - openChatMessageDialog : ${err}.`);
            console.log(err);
          }
        });
    } else {
      this.woOrder.scUserId =  item.UserId;
      this.woOrder.scClientRequestedId = item.UserId;
      this.woOrder.clientName = item.Key;
      this.woOrder.userName = item.Key;

      this.chatMessageDialog = true;
      this.chatList = item.Elements;
      this.chatList = this.chatList.sort((a, b) => b.dateOfRegistration - a.dateOfRegistration);
      this.chatList.forEach(chat => {
        chat.length = item.Elements?.filter(f => f.isView != true)?.length;
      });
    }
  }

  getInitials(name: string): string {
    if (!name || typeof name !== 'string' || name.trim() === '') {
      return '??'; // Default for invalid or empty names
    }

    const nameParts = name.trim().split(/\s+/);

    if (nameParts.length === 0) {
      return '??';
    }

    const firstInitial = nameParts[0].charAt(0).toUpperCase();

    if (nameParts.length > 1) {
      const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    } else {
      // Only one name part, use its first letter twice
      return firstInitial + firstInitial;
    }
  }

  openDialogSendMessage(woOrderId: string, sourceUserId: string) {

    if (woOrderId == null) {
      this.sourceUserId = sourceUserId;
      this.getListUser();
      this.woOrder = {};
      this.displaySendMessage = true;
      this.dialogHeaderSendMessage = this.translateService.instant('message.new_message');
      return;
    } else if (this.woOrder?.id !== undefined && woOrderId === this.woOrderIdSelected) {
      this.displaySendMessage = true;
      this.dialogHeaderSendMessage = this.translateService.instant('message.new_message');
      return;
    }

    this.orderSortingService.getItem(woOrderId).subscribe(
      {
        next: (res) => {
          if (res) {
            this.woOrder = res.data;
            if (this.woOrder != null && this.woOrder != undefined && (this.woOrder.obs == null || this.woOrder.obs == undefined || this.woOrder.obs == '')) {
              this.woOrder.obs = ' - ';
            }
            this.displaySendMessage = true;
            this.dialogHeaderSendMessage = this.translateService.instant('message.new_message');
          }
        },
        error: (err) => {
          console.log(`SfcDashboardServiceComponent - openDialogSendMessage : ${err}.`);
          console.log(err);
        }
      });

    this.woOrderIdSelected = woOrderId;
  }

  getListUser() {
    this.userService.getList().subscribe(
      {
        next: (res) => {
          if (res) {
            this.listUser = res.data;
            this.listUser = this.listUser.filter(f => f.id != this.userId);
          }
        },
        error: (err) => console.log(`ScUserMessageSendComponent - getListUser : ${err}.`)
      });
  }

  refreshData() {
    this.displaySendMessage = false;
    this.getList();
  }

  messageSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: this.translateService.instant('title.success'), detail: this.translateService.instant(message), life: 3000 });
  }

  messageError(message: string) {
    this.messageService.add({ severity: 'warn', summary: this.translateService.instant('title.error'), detail: this.translateService.instant(message), life: 3000 });
  }

  sendMessage() {
    this.payload = {
      message: this.message,
      //woOrderId: this.woOrder.id,
      woOrderId: null,
      userId: this.userTokenService.getUserId(),
      isEmailProcessing: true,
      isProcessingStatusEmail: "OK",
      targetUserId: this.isClient ? this.woOrder.scUserId : this.woOrder.scClientRequestedId,
      sourceUserId: this.userTokenService.getUserId(),
      isSendNotification: false,
      processingStatus: "OK",
      telephone: this.woOrder.clientTelephone,
      email: null,
      language: this.language,
      parameter: null
    };

    this.userService.addUserMessage(this.payload)
      .subscribe((res) => {
        this.messageSuccess('message.send_success');
        this.message = '';
        this.getList();

        setTimeout(() => {
          this.openChatMessageDialog(this.listMessages.find(f => f.Key == this.selectedItem.Key));
        }, 3000);

      },
    error => {
        console.error('Error sending message:', error);
        this.messageError('message.send_error');
      });
  }

}
